<template>
    <div v-loading.fullscreen.lock="loading">

        <subHeader :title="service.title" :subtitle="service.description" :img_header="'dd'"></subHeader>

        <div class="module ptb-100" style="padding-top: 150px;">
            <div class="container">

                <div class="row">
                    <div class="col-sm-9">
                        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm" label-position="top">

                        <!--Primera sección-->
                        <section id="parque" v-if="step == 1">
                            <div class="row">
                                <div class="col-sm-6">
                                    <el-form-item
                                        label="Seleccione el Club o Parque al que desea participar del taller"
                                        prop="getSeat"
                                        :rules="[{required: true, message: 'Seleccione un parque', trigger: ['change', blur]}]">
                                        <el-select
                                            v-model="ruleForm.getSeat"
                                            placeholder="Seleccione"
                                            filterable
                                            @change="getListSports"
                                            class="w-100 shadow-sm">
                                            <el-option v-for="item in listSeats" :key="item.idseat" :label="item.name"
                                                :value="item.idseat" />
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item :label="isGym
                                        ? 'Selecciona el tipo de entrenamiento'
                                        : 'Seleccione el taller en el cual desea participar'
                                        " prop="getSports"
                                        :rules="[{required: true, message: 'Campo obligatorio', trigger: ['change', blur]}]">
                                        <el-select
                                            v-model="ruleForm.getSports"
                                            placeholder="Seleccione una escuela"
                                            @change="getListScheduls" class="w-100 shadow-sm">
                                            <el-option v-for="item in listSports" :key="item.idproduct"
                                                :value="item.idproduct" :label="item.title">
                                                <span style="float: left">{{ item.title }}</span>
                                                <span style="float: right; color: #8492a6; font-size: 13px;">S/ {{ item.price }}</span>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item
                                        label="Selecciona el horario"
                                        prop="getSchedule"
                                        :rules="[{required: true, message: 'Campo obligatorio', trigger: ['change', blur]}]">
                                        <el-select v-model="ruleForm.getSchedule" placeholder="Seleccione un horario"
                                            class="w-100 shadow-sm">
                                            <el-option v-for="item in listScheduls" :key="item.idschedule"
                                                :value="item.idschedule"
                                                :label="`${item.title != '' ? item.title : ''} (Inicia ${moment(item.startdate).format('DD [de] MMMM')}) ${item.schedule}`"
                                                style="width: 100%">
                                                {{ item.title != "" ? item.title : "" }}
                                                {{ " (Inicia " }}{{ item.startdate | moment("DD [de] MMMM") }}{{ ") " }}
                                                {{ item.schedule }}
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>

                                <div class="col-sm-6" style="padding:50px;">
                                    <h3>Importe a pagar</h3>
                                    <h1 v-if="ruleForm.getSports != '' && !promotional.success" style="font-size: 5rem;">
                                        S/ {{ detailSports[0].price }}
                                    </h1>
                                    <h1 v-else style="font-size: 5rem;">S/ 0.00</h1>
                                </div>
                            </div>
                        </section>
                        <!---->

                        <!--segunda sección-->
                        <section id="registro" v-if="step == 2">
                            <h4 class="d-none">Datos del alumno</h4>
                            <el-divider content-position="center">Datos del alumno</el-divider>
                            <div class="ep-step-tree">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <el-form-item label="Tipo de documento"
                                            prop="tdocument"
                                            :rules="[{required: true, message: 'Campo obligatorio', trigger: ['change', blur]}]">
                                            <el-select v-model="ruleForm.tdocument" placeholder="Selecciona" class="shadow-sm">
                                                <el-option v-for="item in listDocuments" :key="item.id" :label="item.name"
                                                    :value="item.id"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                    <div class="col-sm-6">
                                        <el-form-item label="Número de documento" prop="ndocument"
                                            :rules="[{required: true, message: 'Campo obligatorio', trigger: ['change', 'blur']}]">
                                            <el-input v-model="ruleForm.ndocument" maxlength="13" class="shadow-sm" @blur="searchCustomer"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                                <el-form-item label="Nombres y apellidos completos" prop="firstname"
                                    :rules="[{required: true, message: 'Campo obligatorio', trigger: ['change', blur]}]">
                                    <el-input v-model="ruleForm.firstname" maxlength="50" class="shadow-sm"></el-input>
                                </el-form-item>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <el-form-item label="Fecha de nacimiento" prop="fnac"
                                            :rules="[{type: 'date', required: true, message: 'Campo obligatorio', trigger: ['change', 'blur']}]">
                                            <el-date-picker v-model="ruleForm.fnac" type="date" placeholder="seleccione"
                                                default-value="2000-01-01" format="dd/MM/yyyy" class="shadow-sm">
                                            </el-date-picker>
                                        </el-form-item>
                                    </div>
                                    <div class="col-sm-6">
                                        <el-form-item label="Sexo" prop="sex"
                                            :rules="[{required: true, message: 'Campo obligatorio', trigger: ['change', blur]}]">
                                            <el-select v-model="ruleForm.sex" placeholder="Selecciona" class="shadow-sm">
                                                <el-option v-for="item in listSex" :key="item.id" :label="item.name"
                                                    :value="item.id"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </div>

                            </div>

                            <!--Datos de facturación-->
                            <h4 style="margin-top: 20px;" class="d-none">Datos de facturación</h4>
                            <el-divider content-position="center">Datos de facturación</el-divider>
                            <el-form-item label="Selecciona el tipo de comprobante que deseas recibir" prop="voucher"
                                :rules="[{required: true, message: 'Campo obligatorio', trigger: ['change', blur]}]">
                                <el-radio-group v-model="ruleForm.voucher" @change="changeVoucher">
                                    <el-radio v-for="item in listVoucher" :key="item.id" :label="item.id">{{
                                        item.name }}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <div v-if="ruleForm.voucher == 'B'">

                                <div class="row">
                                    <div class="col-sm-6">
                                        <el-form-item label="Tipo de documento"
                                            prop="cTdocument"
                                            :rules="[{required: true, message: 'Campo obligatorio', trigger: ['change', blur]}]">
                                            <el-select v-model="ruleForm.cTdocument" placeholder="Selecciona" class="shadow-sm">
                                                <el-option v-for="item in listDocuments" :key="item.id" :label="item.name"
                                                    :value="item.id"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                    <div class="col-sm-6">
                                        <el-form-item prop="cDniRuc" label="Número de documento"
                                            :rules="[{required: true, message: 'Campo obligatorio', trigger: ['change', blur]}]">
                                            <el-input v-model="ruleForm.cDniRuc" maxlength="8" class="shadow-sm"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>

                                <el-form-item prop="cNameRazon" label="Nombres y apellidos completos"
                                    :rules="[{required: true, message: 'Campo obligatorio', trigger: ['change', blur]}]">
                                    <el-input v-model="ruleForm.cNameRazon" maxlength="100" class="shadow-sm"></el-input>
                                </el-form-item>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <el-form-item prop="cPhone" label="Número de celular"
                                            :rules="[{required: true, message: 'Campo obligatorio', trigger: ['change', blur]}]">
                                            <el-input v-model="ruleForm.cPhone" maxlength="9" class="shadow-sm"></el-input>
                                        </el-form-item>
                                    </div>
                                    <div class="col-sm-6">
                                        <el-form-item prop="cEmail" label="Correo electrónico"
                                            :rules="[
                                                {required: true, message: 'Campo obligatorio', trigger: ['change', blur]},
                                                {type: 'email', message: 'Ingrese dirección de correo electrónico correcta', trigger: ['blur', 'change'],}]">
                                            <el-input v-model="ruleForm.cEmail" maxlength="100" class="shadow-sm"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>

                            <div v-else>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <el-form-item prop="cDniRuc" label="Número de RUC"
                                            :rules="[{required: true, message: 'Campo obligatorio', trigger: ['change', blur]}]">
                                            <el-input v-model="ruleForm.cDniRuc" maxlength="11" class="shadow-sm"></el-input>
                                        </el-form-item>
                                    </div>
                                    <div class="col-sm-6">
                                        <el-form-item prop="cNameRazon" label="Razón social"
                                            :rules="[{required: true, message: 'Campo obligatorio', trigger: ['change', blur]}]">
                                            <el-input v-model="ruleForm.cNameRazon" maxlength="100" class="shadow-sm"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <el-form-item prop="cPhone" label="Número de celular"
                                            :rules="[{required: true, message: 'Campo obligatorio', trigger: ['change', blur]}]">
                                            <el-input v-model="ruleForm.cPhone" maxlength="9" class="shadow-sm"></el-input>
                                        </el-form-item>
                                    </div>
                                    <div class="col-sm-6">
                                        <el-form-item prop="cEmail" label="Correo electrónico"
                                            :rules="[
                                                {required: true, message: 'Campo obligatorio', trigger: ['change', blur]},
                                                {type: 'email', message: 'Ingrese dirección de correo electrónico correcta', trigger: ['blur', 'change'],}]">
                                            <el-input v-model="ruleForm.cEmail" maxlength="100" class="shadow-sm"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>

                                <!--
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label text-left">Dirección*</label>
                                    <div class="col-sm-8">
                                        <el-form-item prop="cAddress"
                                            :rules="[{required: true, message: 'Campo obligatorio', trigger: ['change', blur]}]">
                                            <el-input v-model="ruleForm.cAddress" maxlength="300"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                                -->
                            </div>

                            <!--Terminos y condiciones-->
                            <el-form-item prop="terms" required :rules="[{required: true, message: 'Campo obligatorio', trigger: ['change', blur]}]">
                                <el-checkbox v-model="ruleForm.terms" name="terms">He leído y acepto los
                                    <a href="https://www.serpar.gob.pe/wp-content/uploads/2021/01/terminos.pdf"
                                        target="_blank"><b>Términos
                                            y Condiciones</b></a></el-checkbox>
                            </el-form-item>
                            <el-form-item prop="terms3" required :rules="[{required: true, message: 'Campo obligatorio', trigger: ['change', blur]}]">
                                <el-checkbox v-model="ruleForm.terms3" name="terms3" size="large">
                                    Declaro haber leído y acepto el Protocolo del Taller de Natación o, según corresponda,
                                    el Protocolo
                                    General de Talleres Deportivos y
                                    Culturales.
                                </el-checkbox>
                            </el-form-item>
                            <el-form-item prop="terms2" required :rules="[{required: true, message: 'Campo obligatorio', trigger: ['change', blur]}]">
                                <el-checkbox v-model="ruleForm.terms2" name="terms2" size="large">
                                    Acepto que al realizar la inscripción en el taller y horario seleccionado, no habrá
                                    cambios ni
                                    devoluciones posteriores
                                </el-checkbox>
                            </el-form-item>
                        </section>
                        <!---->

                    </el-form>
                    </div>
                    <div class="col-sm-3">
                        <div class="alert alert-info text-center"><strong>Taller de Natación</strong></div>
                        <table class="table table-success table-striped w-100" style="font-size: 13px;">
                            <tr>
                                <th><b>CATEGORÍA</b></th>
                                <th><b>RANGO EDAD</b></th>
                            </tr>
                            <tbody>
                                <tr>
                                    <td>INICIACIÓN</td>
                                    <td>5 A 7 AÑOS</td>
                                </tr>
                                <tr>
                                    <td>BASICO</td>
                                    <td>8 A 17 AÑOS</td>
                                </tr>
                                <tr>
                                    <td>INTERMEDIO</td>
                                    <td>8 A 17 AÑOS</td>
                                </tr>
                                <tr>
                                    <td>ADULTOS</td>
                                    <td>18 AÑOS A MÁS.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>


                <!--Botonera-->

                <div class="botonera text-center" style="margin-top:50px;">
                    <button class="btn outline-btn mb-3 mt-3" @click.prevent="epBack('ruleForm')">
                        Anterior
                    </button>
                    <button v-if="available" class="btn outline-btn mb-3 mt-3 ml-2"
                        @click.prevent="submitForm('ruleForm')">
                        {{ step == 2 ? "Ir a pagar" : "Siguiente" }}
                    </button>
                </div>

            </div>
        </div>

        <el-dialog title="Seleccione una opción" :visible.sync="dialog_exist_student" width="350px"
            :close-on-click-modal="false" center @close="is_new_student = false">
            <div class="">
                <el-button plain class="w-100" @click="tipoAlumno(false)">Alumno nuevo</el-button>
                <el-button plain class="w-100 mx-0 my-3" @click="tipoAlumno(true)">Soy alumno</el-button>

                <div v-if="is_new_student" class="">

                    <el-input placeholder="Documento del alumno" v-model="document_student"
                        @keypress.enter.native="searchStudent">
                        <el-button slot="append" icon="el-icon-search" @click="searchStudent">Buscar</el-button>
                    </el-input>

                </div>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialog_exist_student = false">Cancelar</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
//components
import subHeader from "@/components/common/subHeader";

import { mapGetters } from 'vuex'

//services
import services from "@/services/services.service"

import moment from "moment";
import PromotionalCode from "@/components/common/PromotionalCode";

export default {
    components: {
        subHeader,
        PromotionalCode
    },
    data() {
        var checkAge = (rule, value, callback) => {
            if (!value) {
                if (!this.ruleForm.getSports)
                    return callback(new Error(`Aún no ha seleccionado ninguna escuela.`));
                else if (this.listScheduls.length == 0)
                    return callback(
                        new Error(`Lo sentimos, no contamos con horarios disponibles.`)
                    );
                else return callback(new Error(`Tiene que seleccionar un horario.`));
            } else {
                callback();
            }
            /*setTimeout(() => {
                          if (!Number.isInteger(value)) {
                            callback(new Error('Please input digits'));
                          } else {
                            if (value < 18) {
                              callback(new Error('Age must be greater than 18'));
                            } else {
                              callback();
                            }
                          }
                        }, 1000);*/
        };
        return {
            moment,
            loading: false,
            service: {},
            school: null,
            pickerOptions: {
                disabledDate(time) {
                    const today = new Date();
                    const maxDate = new Date(2024, 11, 15); // 15/12/2024
                    return time.getTime() < today.setHours(0, 0, 0, 0) || time.getTime() > maxDate.getTime();
                },
            },

            available: true,
            closable: false,
            activeName: "1",
            step: 1,
            totalSteps: 3,
            getCountry: "",
            textePresencial: "Siguiente",
            listSeats: [],
            detailSeat: [],
            listSports: [],
            detailSports: [],
            listScheduls: [],
            detailScheduls: [],
            detailDocs: [],
            detailSex: [],
            listDocuments: [
                {
                    id: "01",
                    name: "DNI",
                },
                {
                    id: "04",
                    name: "Carnet de Extranjeria",
                },
                {
                    id: "07",
                    name: "Pasaporte",
                },
            ],
            listSex: [
                {
                    id: "M",
                    name: "Masculino",
                },
                {
                    id: "F",
                    name: "Femenino",
                },
                {
                    id: "S",
                    name: "Sin especificar",
                },
            ],
            listVoucher: [
                {
                    id: "B",
                    name: "Boleta",
                },
                {
                    id: "F",
                    name: "Factura",
                },
            ],

            isGym: false,
            promotional: {},
            ruleForm: {
                ispromotional: false,
                promotional_code: null,
                getSeat: "",
                getSports: "",
                getSchedule: "",
                nameSchedule: "",
                nameProduct: "",
                priceProduct: 0,
                tdocument: "",
                ndocument: "",
                firstname: "",
                birthday: "",
                fnac: "",
                sex: "",
                phone1: "",
                phone2: "",
                address: "",
                email: "",
                voucher: "B",
                cDniRuc: "",
                cNameRazon: "",
                cAddress: "",
                cPhone: "",
                cEmail: "",
                isGym: false,
            },
            dialog_exist_student: false,
            is_new_student: false,
            exit_student: false,
            document_student: null,
            rules: {
                getSchedule: [
                    {
                        validator: checkAge,
                        trigger: "change",
                    },
                ],
            },

            selectedDate: null, // Fecha seleccionada
            startDate: new Date(2024, 11, 10), // Fecha de inicio del rango (1 de enero de 2024)
            endDate: new Date(2024, 11, 20), // Fecha de fin del rango (31 de diciembre de 2024)
        };
    },
    methods: {
        async init() {
            this.loading = true;
            let res = await services.get(this.school);
            this.service = res.data.details;
            this.listSeats = res.data.coverage
            this.loading = false;
        },
        onPromotional(data) {
            this.promotional = data;
        },
        getListSeats() {
            this.loading = true;
            axios.post(`${process.env.API1}/presencial/seats`).then((response) => {
                this.listSeats = response.data;
                this.loading = false;
                //if (this.isGym) {
                //    this.ruleForm.getSeat = "00037";
                //    this.getListSports();
                //}
            });
        },
        getListSports() {
            try {
                this.loading = true;
                this.ruleForm.getSports = "";
                this.listScheduls = [];
                this.detailSeat = this.listSeats.filter((seat) =>
                    seat.idseat.includes(this.ruleForm.getSeat)
                );
                var formdata = new FormData();
                formdata.append("idseat", this.ruleForm.getSeat);
                axios
                    .post(`${process.env.API1}/presencial/sports`, formdata)
                    .then((response) => {
                        this.listSports = response.data;
                        this.loading = false;

                        if (this.isGym) {
                            this.step = 2;
                            this.ruleForm.getSports = "35";
                            this.getListScheduls();
                        }
                    });
            } catch (error) {
                this.loading = false;
            }
        },
        getListScheduls() {
            try {
                this.loading = true;
                this.ruleForm.ispromotional = false;
                this.promotional = {};
                this.ruleForm.getSchedule = "";
                this.detailSports = this.listSports.filter((sports) =>
                    sports.idproduct.includes(this.ruleForm.getSports)
                );
                if (this.detailSports[0].shopping == 1) {
                    this.available = true;
                    var formdata = new FormData();
                    formdata.append("idseat", this.ruleForm.getSeat);
                    formdata.append("idproduct", this.ruleForm.getSports);
                    axios
                        .post(`${process.env.API1}/presencial/scheduls`, formdata)
                        .then((response) => {
                            this.listScheduls = response.data;
                            this.loading = false;
                            this.$refs.ruleForm.validateField("getSchedule");
                        });
                } else {
                    this.available = false;
                    this.loading = false;
                }
            } catch (error) {
                this.loading = false;
            }
        },
        epBack(formName) {
            if (this.step != 1) {
                this.step--;
                this.ruleForm.terms = false;
                this.textePresencial = "Siguiente";
                this.available = true;
            }
        },
        submitForm(formName) {

            //alert(this.ruleForm.fnac)
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.step < this.totalSteps) this.step++;
                    if (this.step == this.totalSteps) {
                        this.step--;
                    }

                    if (this.step == 2 && this.ruleForm.getSports != "") {
                        if (this.detailSports[0].shopping == 1) this.available = true;
                    }

                    /*
                    if (this.step == 3) {
                      this.dialog_exist_student = true;
                      this.step--;
                    }
                    */

                    //search schedule
                    /*if (this.step == 5) {
                      this.detailScheduls = this.listScheduls.filter((schedul) =>
                        schedul.idschedule.includes(this.ruleForm.getSchedule)
                      );
                      this.detailDocs = this.listDocuments.filter((doc) =>
                        doc.id.includes(this.ruleForm.tdocument)
                      );
                      this.detailSex = this.listSex.filter((sex) =>
                        sex.id.includes(this.ruleForm.sex)
                      );
                      this.ruleForm.birthday = moment(this.ruleForm.fnac).format(
                        "YYYY-MM-DD"
                      );
                    }
                    */

                    if (this.ruleForm.terms == true && this.ruleForm.terms2 == true && this.ruleForm.terms3 == true) {

                        this.loading = true;

                        /*
                        if (this.promotional.success) {
                          this.ruleForm.ispromotional = this.promotional.success;
                          this.ruleForm.promotional_code = this.promotional.code;
                        }
                        */

                        this.detailScheduls = this.listScheduls.filter((schedul) =>
                            schedul.idschedule.includes(this.ruleForm.getSchedule)
                        );

                        this.ruleForm.nameProduct = this.detailSports[0].title;
                        this.ruleForm.priceProduct = this.detailSports[0].price;
                        this.ruleForm.nameSchedule = this.detailScheduls[0].schedule;
                        this.ruleForm.date_visit = moment(this.ruleForm.date_visit).format("YYYY-MM-DD");
                        let formDatas = this.formDatas(this.ruleForm);
                        axios
                            .post(`${process.env.API1}/presencial/register`, formDatas)
                            .then((response) => {
                                this.loading = false;
                                if (response.data.status == "success") {
                                    window.location.href = response.data.url;
                                } else {
                                    this.$alert(response.data.message, "Lo sentimos!", {
                                        confirmButtonText: "Entendido",
                                        type: "error",
                                        center: true,
                                        callback: (action) => { },
                                    });
                                }
                            });
                    }
                } else {
                    return false;
                }
            });
        },
        formDatas(obj) {
            let formData = new FormData();
            for (var key in obj) {
                formData.append(key, obj[key]);
            }
            return formData;
        },
        changeVoucher() {
            this.ruleForm.cDniRuc = "";
            this.ruleForm.cNameRazon = "";
            this.ruleForm.cPhone = "";
            this.ruleForm.cEmail = "";
        },

        tipoAlumno(valor) {
            if (valor) {
                this.is_new_student = true

                console.log('alumno nuevo')

                this.ruleForm.fnac = ""
                //alert( this.ruleForm.birthday)
                this.ruleForm.email = ""
                this.ruleForm.firstname = ""
                this.ruleForm.ndocument = ""
                this.ruleForm.phone1 = ""
                this.ruleForm.sex = ""
                this.ruleForm.tdocument = ""
                this.ruleForm.address = ""

            } else {
                this.dialog_exist_student = false
                this.step++
            }
        },
        searchStudent() {
            //if (this.document_student === null)
            //   return this.$message.error('Falta Ingresar documento de indentidad.');

            //if(document_student == null )
            if (this.document_student.split(" ").join("").length < 8)
                return this.$message.error('Documento de indentidad no debe ser menor a 8 dígitos.');

            this.searchCustomer()
        },
        async searchCustomer() {
            if (this.ruleForm.ndocument && this.ruleForm.ndocument.trim().length >= 8) {
                this.loading = true

                await services.getRenovacionEp(this.ruleForm.ndocument).then((res) => {
                    if (res.data.status) {
                        //this.ruleForm.fnac = moment(res.data.person.birthday).format("DD/MM/YYYY")
                        this.ruleForm.fnac = new Date(res.data.person.birthday);
                        //alert( this.ruleForm.birthday)
                        this.ruleForm.email = res.data.person.email
                        this.ruleForm.firstname = res.data.person.firstname
                        this.ruleForm.ndocument = res.data.person.ndocument
                        this.ruleForm.phone1 = res.data.person.phone1
                        this.ruleForm.sex = res.data.person.sex
                        this.ruleForm.tdocument = res.data.person.tdocument
                        this.ruleForm.address = res.data.person.address

                        this.dialog_exist_student = false
                        //this.step++
                    } else {
                        return this.$message.error('No se encontró coincidencia alguna');
                    }

                    //this.ruleForm.birthday = res.data.person.birthday
                    //this.ruleForm.birthday = res.data.person.birthday
                    //console.log(res)
                }).catch((err) => {
                    this.loading = false
                    alert('Lo sentimos, no se encontró coincidencia alguna.')
                }).finally(() => {
                    this.loading = false
                })
            }

        }

    },
    created() {
        this.$store.dispatch("updateSubRouter", true);
        this.school = (window.location.pathname.startsWith("/")
            ? window.location.pathname.substring(1)
            : window.location.pathname)
            + window.location.search;
        this.init()
        //const params = new URLSearchParams(window.location.search);
        //console.log(this.$route.query)
        /*
        if (params.has('type')) {
            const schoolParam = params.get('type');
            if (schoolParam && schoolParam.trim() !== '') {
                this.school = schoolParam;
                this.init()
            } else {
                console.error('School param is empty or null');
            }
        } else {
            this.getListSeats();
        }
        */

        /*
        let school = this.$route.query.school;
        if (school != null && school != "" && school == "gimnasio")
            this.isGym = true;
        */

        //
    },
};
</script>
<style>
.el-form-item__label{font-weight: 500; color: black !important;}
.el-divider__text{font-weight: 500; color: #202877 !important; font-size: 1.5rem !important;}
</style>



// WEBPACK FOOTER //
// src/components/pages/epresencial/Index.vue